import { getLocale } from "../runtime";

const sv_errortitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Något gick fel`
};

const errortitle = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_errortitle(inputs)
	return "errorTitle";
};

export { errortitle as "errorTitle" };